import React, { useState } from 'react';
import { Button } from '../ui/button';
import { 
  Plus,
  Search,
  BookOpen,
  Loader2,
  FileText
} from 'lucide-react';
import { useKBArticles } from '../../hooks/support/useSupportData';

const KnowledgeBaseTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    skip: 0,
    limit: 20,
    sort: '-created_at'
  });

  // Fetch articles using React Query
  const { data, isLoading: loading, error } = useKBArticles(filters);
  
  const articles = data?.items || [];
  const total = data?.total || 0;

  // Loading state
  if (loading) {
    return (
      <div className="text-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600 mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-300">Loading knowledge base...</p>
      </div>
    );
  }

  // Empty state
  if (articles.length === 0 && !searchQuery) {
    return (
      <div className="text-center py-12">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 mb-4">
          <FileText className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          No articles yet
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">
          Create your first help article to build your knowledge base. Articles help customers find answers on their own.
        </p>
        <Button>
          <Plus className="w-4 h-4 mr-2" />
          Create First Article
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Search and Actions */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 flex-1">
          {/* Search */}
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100"
            />
          </div>

          {/* Category Filter */}
          <select className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100">
            <option value="">All Categories</option>
            <option value="account">Account</option>
            <option value="billing">Billing</option>
            <option value="technical">Technical</option>
            <option value="features">Features</option>
          </select>
        </div>

        {/* Create Article Button */}
        <Button>
          <Plus className="w-4 h-4 mr-2" />
          Create Article
        </Button>
      </div>

      {/* Articles List will go here */}
      <div className="text-center py-8 text-gray-500 dark:text-gray-400">
        Knowledge base articles will be displayed here
      </div>
    </div>
  );
};

export default KnowledgeBaseTab;
